import { render } from "./LoginView.vue?vue&type=template&id=842200d4&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "@/assets/css/login.css?vue&type=style&index=0&id=842200d4&lang=css&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-842200d4"]])

export default __exports__